"use client";

import { motion } from "framer-motion";
import { ComponentProps } from "react";

type FadeInProps = ComponentProps<typeof motion.div> & {
  delay?: number;
  duration?: number;
  y?: number;
  once?: boolean;
  inView?: boolean;
  /** Externally controlled trigger — bypasses framer-motion's own viewport
      detection so callers can sync this fade with another in-view check
      (e.g. gating a sibling CSS animation off the same threshold). */
  active?: boolean;
};

export default function FadeIn({
  delay = 0,
  duration = 0.4,
  y = 16,
  once = true,
  inView = true,
  active,
  children,
  ...rest
}: FadeInProps) {
  const initial = { opacity: 0, y };
  const animate = { opacity: 1, y: 0 };
  const transition = { duration, delay };

  const motionProps =
    active !== undefined
      ? {
          initial,
          animate: active ? animate : initial,
          transition,
        }
      : inView
      ? {
          initial,
          whileInView: animate,
          viewport: { once },
          transition,
        }
      : {
          initial,
          animate,
          transition,
        };

  return (
    <motion.div {...motionProps} {...rest}>
      {children}
    </motion.div>
  );
}
